module.exports = "<app-voucher-searchmenu></app-voucher-searchmenu>\n<div class=\"clearfix\"></div>\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/help/help.component.html
// module id = ./src/app/help/help.component.html
// module chunks = main